import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import type { ChatAnswer } from 'owa-search-copilot-answer-shared';

export const setChatAnswerMutator: (chatAnswer: ChatAnswer | undefined) => void = mutatorAction(
    'SET_COPILOT_SEARCH_CHAT_ANSWER',
    (chatAnswer: ChatAnswer | undefined): void => {
        getStore().chatAnswer = chatAnswer;
    }
);

export const setIsLoadingMutator: (isLoading: boolean) => void = mutatorAction(
    'SET_COPILOT_SEARCH_IS_LOADING',
    (isLoading: boolean): void => {
        getStore().isLoading = isLoading;
    }
);

export const setCurrentQueryMutator: (query: string | undefined) => void = mutatorAction(
    'SET_COPILOT_SEARCH_CURRENT_QUERY',
    (query: string | undefined): void => {
        getStore().currentQuery = query;
    }
);

export const setScrollMinimizedMutator: (isMinimized: boolean) => void = mutatorAction(
    'SET_COPILOT_SEARCH_SCROLL_MINIMIZED',
    (isMinimized: boolean): void => {
        getStore().isScrollMinimized = isMinimized;
    }
);
